import { render, staticRenderFns } from "./GameBoard.vue?vue&type=template&id=85c28b96&"
import script from "./GameBoard.vue?vue&type=script&lang=js&"
export * from "./GameBoard.vue?vue&type=script&lang=js&"
import style0 from "./GameBoard.vue?vue&type=style&index=0&id=85c28b96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports